    import axiosAuth from '../../../shared/configs/axios-auth'

    const getDefaultState = () => {
        return {
            variantsTemplates: [],
        }
    }
    
    const state = getDefaultState()

    const getters = {
        variantsTemplates: state => {
            return state.variantsTemplates
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        variantsTemplates: (state, payload) => {
            state.variantsTemplates = payload
        },
    }

    const actions = {
       
        getVariantsTemplates: ({commit}) =>{
            commit('updating', true)
            axiosAuth.get('/variantsTemplates')
            .then(
                res => {
                    commit('updating', false)
                    if(!res.data.message){
                        commit('variantsTemplates', res.data)
                    }

                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)
                }
              )
        },

        postVariantsTemplate ({commit, dispatch}, payload) {
            commit('updating', true)
            axiosAuth.post('/variantsTemplates', payload)
                .then(
                    res => {
                        commit('trash', res)
                        commit('updating', false)
                        dispatch('getVariantsTemplates')
                    }
                )
                .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
                )
        },

        updateVariantsTemplate: ({commit, dispatch}, payload) => {
            console.log('payload:', payload)
            
            commit('updating', true)
            axiosAuth.patch('/variantsTemplates/'+ payload._id, payload.data)
            .then(
                res => {
                    commit('trash', res)
                    commit('updating', false)
                    dispatch('getMenus')
                }
              )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },

        deleteVariantsTemplate: ({commit, dispatch}, payload) => {
            commit('updating', true)
            axiosAuth.delete('/variantsTemplates/'+ payload._id)
            .then(
                () => {
                    dispatch('getVariantsTemplates')
                }
              )
            .catch(
                error => {
  
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },
    }

    export default {
        state,
        getters,
        mutations,
        actions
    }